import React, {useState} from 'react';
import axios from 'axios';
import {Button, Radio, RadioChangeEvent} from 'antd';

const HashAlgorithm = () => {
    const [algorithm, setAlgorithm] = useState<string>('sha2-512');


    const [msg, setMsg] = useState<string>('');

    const [result, setResult] = useState<boolean>(false);
    const [response, setResponse] = useState<any>(null);

    const handleSubmit = async () => {
        try {
            const data = {
                msg : msg,
            }
            const result = await axios.post(`/api/hash/${algorithm}`, data );
            setResponse(result.data);
        } catch (error) {
            setResult(false);
            console.error('Error during the request:', error);
            setResponse(error);
        }
    };

    const algorithmOptions = [
      //  { label: 'SHA-256', value: 'sha2-256' },
        { label: 'SHA-512', value: 'sha2-512' },
    ];


    const onChangeAlgorithm = ({ target: { value } }: RadioChangeEvent) => {
        setAlgorithm(value);
        setMsg('');
        setResult(false);
        setResponse(null);
    };



    return (

        <div>
            <div style={{marginBottom:"20px"}}>
                <Radio.Group options={algorithmOptions} onChange={onChangeAlgorithm} value={algorithm} optionType="button"  buttonStyle="solid" />
            </div>

            <div className="container">
                <div className="input-group">
                    <label>MSG:</label>
                    <input type="text" value={msg} onChange={(e) => setMsg(e.target.value)}/>
                </div>
            </div>
            <div style={{marginTop: "30px"}}>
                <Button style={{width: "100px"}} type="primary" onClick={handleSubmit}>실행</Button>
            </div>
            {response &&(
                <div style={{minHeight: "500px"}}>
                    <h3>Response:</h3>
                    {result ?
                        <pre>{JSON.stringify(response, null, 2)}</pre>
                        :
                        <div className="container">
                            <div className="input-group">
                                <label>MSG:</label>
                                <input type="text" value={response.msg} readOnly={true}/>
                            </div>
                            <div className="input-group">
                                <label>MD:</label>
                                <input type="text" style={{color:"blue", fontSize:"10px"}} value={response.md} readOnly={true}/>
                            </div>
                        </div>
                    }


                </div>
            )}
        </div>
    );
};

export default HashAlgorithm;
